import {
  BaseAgentFields,
  FizAgent,
  IpAgent,
  UrAgent,
} from "../../types/agentTypes";
import AgentLegalForm from "../../enum/AgentLegalForm.enum";

export const initialBaseState: BaseAgentFields & { format: "" } = {
  format: "",
  type_motivation: "",
  lang_dog: "",
  first_name: "",
  last_name: "",
  patronymic: "",
  first_name_am: "",
  last_name_am: "",
  patronymic_am: "",
  fio: "",
  fio_am: "",
  title: "Mr",
  is_active: true,
  privileges: "AGENT",
  inn: "",
  email: "",
  phone: "",
  manager_id_title: false,
  manager_id: "",
  is_have_tn: false,
  client_id_tn: "",
  data_end_doc: "",
  contact_fio: "",
  contact_email: "",
  contact_phone: "",
  contract_number: "",
  contract_date: "",
  is_o: 1,
  user_id_tn: "",
  post_adress: "",
  include_belarus_citizens: false,
  is_technical: false,
  address_am: "",
  full_name_am: "",
  urid_adress_am: "",
};

export const initialUrAgent: UrAgent = {
  ...initialBaseState,
  format: AgentLegalForm.COMPANY,
  full_name: "",
  lite_name: "",
  urid_adress: "",
  urid_adress_eng: "",
  oktpo: "",
  kpp: "",
  okved: "",
  okato: "",
  authority_basis: "",
  data_authority_start: "",
  data_authority_end: "",
  ogrnip: "",
  full_name_am: "",
  urid_adress_am: "",
};

export const initialFizAgent: FizAgent = {
  ...initialBaseState,
  format: AgentLegalForm.PERSON,
  doc_series: "",
  doc_number: "",
  birth_date: "",
  document_issue: "",
  document_date_issue: "",
  document_issue_code: "",
  snils: "",
};

export const initialIpAgent: IpAgent = {
  ...initialBaseState,
  format: AgentLegalForm.ENTREPRENEUR,
  doc_series: "",
  doc_number: "",
  lite_name: "",
  full_name: "",
  urid_adress: "",
  birth_date: "",
  document_issue: "",
  document_date_issue: "",
  document_issue_code: "",
  snils: "",
  ogrnip: "",
  full_name_am: "",
  urid_adress_am: "",
};

export const agentInitialStates = {
  base: initialBaseState,
  [AgentLegalForm.PERSON]: initialFizAgent,
  [AgentLegalForm.ENTREPRENEUR]: initialIpAgent,
  [AgentLegalForm.COMPANY]: initialUrAgent,
};
